// 🔧 core_demo_profile.js
// ✅ Purpose: Defines the default Core Package seed profile
// ✅ Features:
// - Controls what the Seed Engine builds
// - Separates demo configuration from engine code
// - Future-ready for QA, Stress Test, and Personalized Demo profiles
// - Fully block-commented for clarity and future devs

export const CORE_DEMO_PROFILE = {
  key: "core_demo",

  label: "Core Demo",

  version: 1,

  industry: "car_show",

  enabledSeeders: {
    event: true,
    content: true,
    seo: true,
    map: true,
    categories: true,
    entries: true,
    users: true,
    votes: true,
    schedule: true,
  },

  counts: {
    entries: 50,
    users: 150,
    votes: 750,
  },

  addOns: {
    sponsors: false,
    volunteers: false,
    vendors: false,
    tickets: false,
    auction: false,
    passport: false,
    merch: false,
  },
};